import { defineComponent as _defineComponent } from 'vue'
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { store } from '@/store';
import viewportEventsService from '@/core/responsive/viewport/viewport-events.service';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'BodyPadding',
  setup(__props) {

const showBodyPadding = computed<boolean>(() => store.getters['app/showBodyPadding']);
const hideNavigationSpacer = computed<boolean>(() => store.getters['app/hideNavigationSpacer']);
const isPrivateMode = computed<boolean>(() => store.getters['app/isPrivateMode']);
const searchResultUrl = computed<string>(() => store.getters['app/searchResultUrl']);
const showAuthTopBar = computed<boolean>(() => store.getters['app/showAuthTopBar']);
const showEmptyTopBar = computed<boolean>(() => store.getters['app/showEmptyTopBar']);
const usp = computed<IUsp>(() => store.getters['app/usp']);
const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const menuTheme = computed<MenuThemeSettings>(() => store.getters['app/menuTheme']);

const checkoutUrl = computed<string>(() => store.getters['app/checkoutUrl']);
const basketUrl = computed<string>(() => store.getters['app/basketUrl']);
const quoteBasketUrl = computed<string>(() => store.getters['app/quoteBasketUrl']);

const isMegaMenuOpen = computed<boolean>(() => store.getters['navigation/isMegaMenuOpen']);
const isSearchOpen = computed<boolean>(() => store.getters['navigation/isSearchOpen']);

const route = useRoute();
const isSearchPage = computed<boolean>(() => route.path === searchResultUrl.value);
const showBodyPaddingBorder = computed<boolean>(() => showBodyPadding.value && !hideNavigationSpacer.value);

const breakpoints = useBreakpoints();
const borderAlwaysOnTop = computed<boolean>(() => showBodyPaddingBorder.value && breakpoints.value.large);

const borderOnTop = ref<boolean>(false);
const delayBorderOnTop = ref<boolean>(false);
const scrollCallbackIndex = ref<number | undefined>();
const lastScrollTop = ref<number>(0);

watch(isSearchOpen, onIsSearchOpenChange);

onMounted(() => {
    scrollCallbackIndex.value = viewportEventsService.setCallback(onScroll);
});

onBeforeUnmount(() => {
    viewportEventsService.removeCallback(scrollCallbackIndex.value);
    scrollCallbackIndex.value = undefined;
});

function onIsSearchOpenChange() {
    if (!borderAlwaysOnTop.value) {
        return;
    }
    if (isSearchOpen.value) {
        resetBorderOnTop();
    } else {
        delayBorderOnTop.value = isMegaMenuOpen.value;
    }
}

function onScroll() {
    const currentScrollTop = viewportEventsService.viewport.scrollY;
    if (currentScrollTop < 0) {
        return;
    }
    if (lastScrollTop.value < currentScrollTop) {
        // Scrolling down
        borderOnTop.value = false;
    } else {
        delayBorderOnTop.value = isMegaMenuOpen.value;
    }
    lastScrollTop.value = currentScrollTop;
}

watch(isMegaMenuOpen, onIsMegaMenuOpenChange);

function onIsMegaMenuOpenChange() {
    if (!borderAlwaysOnTop.value) {
        return;
    }
    if (isMegaMenuOpen.value) {
        setBorderOnTop();
    } else {
        setTimeout(resetBorderOnTop, 850);
    }
}

function resetBorderOnTop() {
    borderOnTop.value = viewportEventsService.viewport.scrollY === 0 && !isSearchOpen.value;
}

function setBorderOnTop() {
    if (!delayBorderOnTop.value) {
        resetBorderOnTop();
    } else {
        delayBorderOnTop.value = false;
        setTimeout(resetBorderOnTop, 850);
    }
}

function isBasketOrCheckoutPage() {
    const paymentUrl = checkoutUrl.value + '/payment';
    return route.path === basketUrl.value ||
           route.path === quoteBasketUrl.value ||
           route.path === checkoutUrl.value ||
           route.path === paymentUrl;
}

const showContentPadding = computed<boolean>(() => {
    return !isBasketOrCheckoutPage() && !menuTheme.value.removeSpacingBeforeContent;
});


return { __sfc: true,showBodyPadding, hideNavigationSpacer, isPrivateMode, searchResultUrl, showAuthTopBar, showEmptyTopBar, usp, theme, menuTheme, checkoutUrl, basketUrl, quoteBasketUrl, isMegaMenuOpen, isSearchOpen, route, isSearchPage, showBodyPaddingBorder, breakpoints, borderAlwaysOnTop, borderOnTop, delayBorderOnTop, scrollCallbackIndex, lastScrollTop, onIsSearchOpenChange, onScroll, onIsMegaMenuOpenChange, resetBorderOnTop, setBorderOnTop, isBasketOrCheckoutPage, showContentPadding }
}

})